// import React, { useEffect } from "react";
// import {
//   InfoTimeCard,
//   InfoTimeCardAdv,
//   NewTable,
//   StatusTags,
// } from "../../../../../../../../components";
// import { mapTableRows } from "../../../../../../../../utils";
// import {
//   accountpayableadjustmenttableData1,
//   accountpayableadjustmenttableData2,
// } from "../../../../../../../../assets/data/candidatesData";
// import { useDispatch } from "react-redux";
// import { setCurrentPayrollEditing } from "../../../../../../../../redux/slices/payroll/payrollSlice";

// const Adjustments = ({rowData}) => {
//   const dispatch = useDispatch()
//   useEffect(() => {
//     dispatch(setCurrentPayrollEditing({
//       tabswitched:true
//     }))
//   },[])
//   const columns = [
//     { key: "jobTitle", label: "Job Title" },
//     { key: "clientName", label: "Client Name" },
//     {
//       key: "status",
//       label: "Status",
//       render: (row) => <StatusTags tag={"Active"} />,
//     },
//     { key: "period", label: "Period" },
//     { key: "originalHours", label: "Original Hours" },
//     { key: "revisedHours", label: "Revised Hours" },
//     { key: "originalPay", label: "Original Pay" },
//     { key: "revisedPay", label: "Revised Pay" },
//     { key: "difference", label: "Difference" },
//     {
//       key: "empty",
//       label: " ",
//       render: (row) => <span className="text-danger">{row.empty}</span>,
//     },
//   ];

//   const columns2 = [
//     { key: "jobTitle", label: "Job Title" },
//     { key: "clientName", label: "Client Name" },
//     {
//       key: "status",
//       label: "Status",
//       render: (row) => <StatusTags tag={"Active"} />,
//     },
//     { key: "period", label: "Period" },
//     { key: "originalHours", label: "Original Hours" },
//     { key: "revisedHours", label: "Revised Hours" },
//     { key: "originalPay", label: "Original Pay" },
//     { key: "revisedPay", label: "Revised Pay" },
//     { key: "difference", label: "Difference" },
//     {
//       key: "empty1",
//       label: " ",
//       render: (row) => <span className="text-success">{row.empty1}</span>,
//     },
//   ];

//   const ShortPayments = accountpayableadjustmenttableData1;
//   const ExcessPayments = accountpayableadjustmenttableData2;
//   const ShortPayments2 = [];
//   const ExcessPayments2 = [];
//   // const mappedRows = mapTableRows(ShortPayments, columns);
//   // const mappedRows2 = mapTableRows(ExcessPayments, columns2);
//   const mappedRows = mapTableRows(ShortPayments2, columns);
//   const mappedRows2 = mapTableRows(ExcessPayments2, columns2);
//   return (
//     <div className="p-8 ">
//       <div className="flex justify-between">
//         <h6>Short Payments</h6>
//         <div className="mb-2">
//           <InfoTimeCardAdv
//             title="Short Payments"
//             color="primary"
//             // value={"-1200"}
//             value={"0"}
//             prefix={"$"}
//             type2
//           />
//         </div>
//       </div>
//       <NewTable rows={mappedRows} columns={columns} hideToolBar showCheckbox />
//       <div className="flex justify-between mt-5">
//         <h6>Excess Payments</h6>
//         <div className="mb-2">
//           <InfoTimeCardAdv
//             title="Excess Payments"
//             color="success"
//             // value={"1200"}
//             value={"0"}
//             prefix={"$"}
//             type2
//           />
//         </div>
//       </div>
//       <NewTable
//         rows={mappedRows2}
//         columns={columns2}
//         hideToolBar
//         showCheckbox
//       />
//     </div>
//   );
// };

// export default Adjustments;

import { useCallback, useEffect, useState } from "react";
import {
  InfoTimeCardAdv,
  InfoCardNewAdv,
  NewTable,
  NoData,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
} from "../../../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../../../utils";
// import { formatCurrency } from "../../../../../utils/stringUtils";
import { useDispatch, useSelector } from "react-redux";
// import axiosRequest from "../../../../../redux/slices/universal/axiosService";
// import { ENDPOINTS } from "../../../../../redux/apiConfig";
// import { usePagination } from "../../../../../hooks";
// import { RecordStatus } from "../../../../../assets/data/enumData";
import { formatCurrency } from "../../../../../../../../utils/stringUtils";
import axiosRequest from "../../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../../redux/apiConfig";
import { usePagination } from "../../../../../../../../hooks";
import { RecordStatus } from "../../../../../../../../assets/data/enumData";
import { setCurrentPayrollEditing } from "../../../../../../../../redux/slices/payroll/payrollSlice";

const Adjustments = ({ rowData }) => {
  console.log({ rowData });
  const dispatch = useDispatch();
  const { currentPayrollEditing } = useSelector((state) => state.payRoll) || {};

  // const { rowData?.employeeId?.uiid } = useSelector((state) => state?.employee);
  useEffect(() => {
    dispatch(
      setCurrentPayrollEditing({
        tabswitched: true,
      })
    );
  }, []);
  const [adjustments, setAdjustments] = useState({
    short: [],
    excess: [],
    totalShort: 0,
    totalExcess: 0,
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(25);
  const ShortColumns = [
    {
      key: "jobTitle",
      label: "Job Title",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobTitle}</span>,
    },
    {
      key: "clientName",
      label: "Client Name",
      render: (row) => <span>{row?.clientId?.businessName}</span>,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={RecordStatus.find((list) => list.value === row.status).label}
        />
      ),
      sortable: false,
    },
    {
      key: "period",
      label: "Period",
      render: (row) => (
        <span>
          {dateFormator(row?.period?.from)} - {dateFormator(row?.period?.to)}
        </span>
      ),
    },
    {
      key: "originalHours",
      label: "Original Hours",
      render: (row) => <span>{row?.hours?.original}</span>,
    },
    {
      key: "revisedHours",
      label: "Revised Hours",
      render: (row) => <span>{row?.hours?.revised}</span>,
    },
    {
      key: "originalPay",
      label: "Original Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.original)}</span>,
    },
    {
      key: "revisedPay",
      label: "Revised Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.revised)}</span>,
    },
    {
      key: "difference",
      label: "Difference",
      render: (row) => (
        <span>{formatCurrency(row?.pay?.original - row?.pay?.revised)}</span>
      ),
    },
    // {
    //   key: "paymentStatus",
    //   label: "Status",
    //   render: (row) => <span>{row?.usage ? "Paid" : "Pending"}</span>,
    // },

    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex items-center gap-2 flex-row">
    //       <Button
    //         type="icon"
    //         icon="visibility"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />

    //       <Button
    //         type="icon"
    //         icon="delete"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //     </div>
    //   ),
    // },
  ];

  const Excesscolumns = [
    {
      key: "jobTitle",
      label: "Job Title",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobTitle}</span>,
    },
    {
      key: "clientName",
      label: "Client Name",
      render: (row) => <span>{row?.clientId?.businessName}</span>,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={RecordStatus.find((list) => list.value === row.status).label}
        />
      ),
      sortable: false,
    },
    {
      key: "period",
      label: "Period",
      render: (row) => (
        <span>
          {dateFormator(row?.period?.from)} - {dateFormator(row?.period?.to)}
        </span>
      ),
    },
    {
      key: "originalHours",
      label: "Original Hours",
      render: (row) => <span>{row?.hours?.original}</span>,
    },
    {
      key: "revisedHours",
      label: "Revised Hours",
      render: (row) => <span>{row?.hours?.revised}</span>,
    },
    {
      key: "originalPay",
      label: "Original Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.original)}</span>,
    },
    {
      key: "revisedPay",
      label: "Revised Pay",
      render: (row) => <span>{formatCurrency(row?.pay?.revised)}</span>,
    },
    {
      key: "difference",
      label: "Difference",
      render: (row) => (
        <span>{formatCurrency(row?.pay?.original - row?.pay?.revised)}</span>
      ),
    },
    // {
    //   key: "paymentStatus",
    //   label: "Status",
    //   render: (row) => <span>{row?.usage ? "Paid" : "Pending"}</span>,
    // },

    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex items-center gap-2 flex-row">
    //       <Button
    //         type="icon"
    //         icon="visibility"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />

    //       <Button
    //         type="icon"
    //         icon="delete"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    console.log("rowData.id",rowData.id);
    const fetchAdjustments = async () => {
      const [shortAdjustments, excessAdjustments] = await Promise.allSettled([
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEE_ADJUSTMENTS.GET_ALL,
          params: {
            coll: "EmpAdjustment",
            ref: "Placement Client",
            incl: ["jobInfo", "businessName"],
            lim: limit,
            pg: page,
            fil: JSON.stringify({
              // "usage.finalised": { type: "NONE", value: false },
              usage: {
                type: "OR",
                value: [
                  { "usage.payrollId": rowData.id },
                  { "usage.finalised": false },
                  { usage: { $eq: {} } },
                  { usage: { $exists: false } }
                ],
              },
              employeeId: { type: "NONE", value: rowData?.employeeId?.uiid },
              type: { type: "NONE", value: 1 },
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.EMPLOYEE_ADJUSTMENTS.GET_ALL,
          params: {
            coll: "EmpAdjustment",
            ref: "Placement Client",
            incl: ["jobInfo", "businessName"],
            lim: limit,
            pg: page,
            fil: JSON.stringify({
              usage: {
                type: "OR",
                value: [
                  { "usage.payrollId": rowData.id },
                  { "usage.finalised": false },
                  { usage: { $eq: {} } },
                  { usage: { $exists: false } } 
                ],
              },
              employeeId: { type: "NONE", value: rowData?.employeeId?.uiid },
              type: { type: "NONE", value: 2 },
            }),
          },
        }),
      ]);

      setAdjustments({
        short: shortAdjustments?.value,
        excess: excessAdjustments?.value,
      });
    };
    if (rowData?.employeeId?.uiid) fetchAdjustments();
  }, [limit, page, rowData]);

  const mappedShortRows = adjustments.short?.success
    ? mapTableRows(
        adjustments?.short?.data?.data?.map((item) => ({
          ...item,
          id: item.uiid,
        })) || [],
        ShortColumns
      )
    : [];
  const mappedExcessRows = adjustments.excess?.success
    ? mapTableRows(
        adjustments?.excess?.data?.data?.map((item) => ({
          ...item,
          id: item.uiid,
        })) || [],
        Excesscolumns
      )
    : [];

  const handleCheckBox = useCallback(
    async (type, ids = []) => {
      console.log("triggered selection for", type, "ids", ids);
      switch (type) {
        case 1:
          {
            const shortIds = ids.map((id) => Number(id));
            console.log(
              "db data ",
              adjustments?.short?.data?.data,
              "shortIds",
              shortIds
            );
            const filteredShort = adjustments?.short?.data?.data?.filter(
              (item) => shortIds.includes(item?.uiid)
            );
            const totalShort = filteredShort?.reduce(
              (acc, item) => acc + item?.pay?.original - item?.pay?.revised,
              0
            );
            console.log("short", filteredShort || [], totalShort);
            setAdjustments((prev) => ({ ...prev, totalShort }));
            //here update saga store
            dispatch(
              setCurrentPayrollEditing({
                adjustmentsViewed: true,
                shortIds: filteredShort?.map((item) => item?.uiid),
                shortDetails: filteredShort,
                totalShort,
              })
            );
          }
          break;
        case 2:
          {
            const shortIds = ids.map((id) => Number(id));
            const filteredExcess = adjustments?.excess?.data?.data?.filter(
              (item) => shortIds.includes(item?.uiid)
            );
            const totalExcess = filteredExcess?.reduce(
              (acc, item) => acc + item?.pay?.original - item?.pay?.revised,
              0
            );
            console.log("excess", filteredExcess || [], totalExcess);
            setAdjustments((prev) => ({ ...prev, totalExcess }));
            //here update saga store
            dispatch(
              setCurrentPayrollEditing({
                adjustmentsViewed: true,
                excessIds: filteredExcess?.map((item) => item?.uiid),
                excessDetails: filteredExcess,
                totalExcess: Math.abs(totalExcess),
              })
            );
          }
          break;
        default:
          showToast("Unable to process the adjustment selection", "error", 3000);
      }
    },
    [adjustments, rowData.id]
  );

  return (
    <div className="px-4 py-2 border-[1px] border-neutrals-50 rounded min-h-[73vh]">
      <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Short Payments"} />
            </div>
          }
          RightSection={
            <>
              {/* <div>
                <InfoTimeCardAdv
                  title="Short Payments"
                  value={formatCurrency(adjustments?.totalShort || 0)}
                  // prefix="$"
                  suffix=""
                  color="danger"
                  size="sm"
                />
              </div> */}
              <div>
                <InfoCardNewAdv
                  layout="option12"
                  title="Short Payments"
                  value={formatCurrency(adjustments?.totalShort || 0)}
                  valueConfig={{ className: "text-danger! text-[24px]!" }}
                />
              </div>
            </>
          }
        />
      </div>
      <div>
        <div className="mt-4">
          {adjustments?.short?.data?.data?.length > 0 ? (
            <NewTable
              showCheckbox
              rows={mappedShortRows}
              columns={ShortColumns}
              defaultSelectedRows={
                // rowData?.adjustments?.short?.ids?.map((a) => a.uiid) || []
                currentPayrollEditing?.shortDetails?.map((a) => a.uiid) || []

              }
              onSelectionChange={(id) => handleCheckBox(1, id)}
              // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
              hideToolBar
            />
          ) : (<NoData/>)}
        </div>
      </div>

      <div className="mt-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Excess Payments"} />
            </div>
          }
          RightSection={
            <>
              {/* <div>
                <InfoTimeCardAdv
                  title="Excess Payments"
                  value={`${formatCurrency(adjustments?.totalExcess || 0)}`}
                  // prefix="$"
                  suffix=""
                  color="success"
                  size="sm"
                />
              </div> */}
              <div>
                <InfoCardNewAdv
                  layout="option12"
                  title="Excess Payments"
                  value={`${formatCurrency(adjustments?.totalExcess || 0)}`}
                  valueConfig={{ className: "text-success! text-[24px]!" }}
                />
              </div>
            </>
          }
        />
      </div>
      <div className="mt-4">
        {adjustments?.excess?.data?.data?.length > 0 ? (
          <NewTable
            showCheckbox
            rows={mappedExcessRows}
            columns={Excesscolumns}
            defaultSelectedRows={
              // rowData?.adjustments?.excess?.ids?.map((a) => a.uiid) || []
              currentPayrollEditing?.excessDetails?.map((a) => a.uiid) || []
            }
            onSelectionChange={(id) => handleCheckBox(2, id)}
            // defaultSelectedRows={
            //   currentPayrollEditing?.adjustmentsViewed
            //     ? currentPayrollEditing?.excessIds
            //     : rowData?.adjustments?.excess?.ids
            // }
            // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
            hideToolBar
          />
        ) : (<NoData/>)}
      </div>
    </div>
  );
};

export default Adjustments;
